import Chart from 'react-apexcharts'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, Select, Tag } from 'antd'
import { ToastContainer } from 'react-toastify'
import {
  ContainerTitle,
  DivTitle,
} from '../../../components/TitlePage/TitlePage'
import { Loading } from '../../../components/Loading/Loading'
import DatesPicker from '../../../components/Calendar/datePicker'
import { colors } from '../../../theme'
import { useGestaoTenantDetalhe } from './useGestaoTenantDetalhe'
import {
  FASE_LABELS,
  formatData,
  formatDataHora,
  formatHealth,
  formatTaxaFalha,
} from '../gestaoTenants.helpers'
import {
  Carimbo,
  CardsGrid,
  ChartWrapper,
  Container,
  FilterBar,
  FilterField,
  HeaderBar,
  MetricCard,
  MetricHint,
  MetricTitle,
  MetricValue,
  SectionTitle,
} from '../GestaoTenants.style'

const GRANULARIDADES = [
  { value: 'DIA', label: 'Dia' },
  { value: 'SEMANA', label: 'Semana' },
  { value: 'MES', label: 'Mês' },
]

export function GestaoTenantDetalhe() {
  const {
    drill,
    isLoading,
    recalculando,
    granularidade,
    setGranularidade,
    onChangeDataInicio,
    onChangeDataFim,
    recalcular,
    voltar,
  } = useGestaoTenantDetalhe()

  const serie = drill?.serie ?? []
  const chartSeries = [
    { name: 'WhatsApp', data: serie.map(s => s.whatsappEnviado) },
    { name: 'E-mail', data: serie.map(s => s.emailEnviado) },
    { name: 'Baixas', data: serie.map(s => s.numBaixas) },
  ]
  const chartOptions: ApexCharts.ApexOptions = {
    // Sem `theme.mode` o ApexCharts mantem o default CLARO nos rotulos de eixo
    // (#373d3f), na legenda, na grade e no tooltip — trocar so o array `colors`
    // das series nao alcanca nada disso.
    theme: { mode: 'dark' },
    chart: {
      toolbar: { show: false },
      background: 'transparent',
      foreColor: colors.grey700,
    },
    grid: { borderColor: colors.grey300 },
    tooltip: { theme: 'dark' },
    // Verde claro / verde escuro / cinza: tres verdes medios ficavam ambiguos.
    colors: [colors.secondary, colors.lilas, colors.system],
    stroke: { curve: 'smooth', width: 3 },
    xaxis: { categories: serie.map(s => formatData(s.data)) },
    legend: { position: 'top' },
    dataLabels: { enabled: false },
  }

  return (
    <Container>
      <ToastContainer theme="dark" />
      <ContainerTitle>
        <DivTitle color={colors.primaryText} size={24}>
          {drill ? drill.nome : 'Tenant'}
        </DivTitle>
      </ContainerTitle>

      <HeaderBar>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button onClick={voltar}>Voltar</Button>
          {drill ? <Tag>{FASE_LABELS[drill.fase]}</Tag> : null}
          <Carimbo>
            Atualizado em: {formatDataHora(drill?.atualizadoEm ?? null)}
          </Carimbo>
        </div>
        <Button type="primary" loading={recalculando} onClick={recalcular}>
          {recalculando ? 'Recalculando…' : 'Recalcular este tenant'}
        </Button>
      </HeaderBar>

      <FilterBar>
        <FilterField>
          <span>De</span>
          <DatesPicker
            size="150px"
            background
            handleDataSelecionada={onChangeDataInicio}
          />
        </FilterField>
        <FilterField>
          <span>Até</span>
          <DatesPicker
            size="150px"
            background
            handleDataSelecionada={onChangeDataFim}
          />
        </FilterField>
        <FilterField>
          <span>Granularidade</span>
          <Select
            style={{ width: 140 }}
            value={granularidade}
            onChange={setGranularidade}
            options={GRANULARIDADES}
          />
        </FilterField>
      </FilterBar>

      {isLoading || !drill ? (
        <Loading contrast={false} />
      ) : (
        <>
          <SectionTitle>Saúde e volume</SectionTitle>
          <CardsGrid>
            <MetricCard>
              <MetricTitle>Health score</MetricTitle>
              <MetricValue>
                {formatHealth(drill.estado.healthScore)}
              </MetricValue>
              <MetricHint>0 a 100</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Clientes</MetricTitle>
              <MetricValue>{drill.estado.numClientes}</MetricValue>
              <MetricHint>{drill.estado.numProdutos} produtos</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Nº de vendas na base</MetricTitle>
              <MetricValue>{drill.estado.numVendaItens}</MetricValue>
              <MetricHint>
                Última venda: {formatData(drill.estado.dataUltimaVenda)}
              </MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Vínculos</MetricTitle>
              <MetricValue>
                {drill.vinculos.adminsAtivos}/{drill.vinculos.vendedoresAtivos}
              </MetricValue>
              <MetricHint>Admins / vendedores ativos</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Usuários ativos (período)</MetricTitle>
              <MetricValue>{drill.vinculos.usuariosAtivosPeriodo}</MetricValue>
              <MetricHint>Com login no período</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Último login</MetricTitle>
              <MetricValue>
                {formatDataHora(drill.vinculos.ultimoLogin)}
              </MetricValue>
              <MetricHint>Acesso mais recente da conta</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Última atividade</MetricTitle>
              <MetricValue>
                {formatDataHora(drill.estado.dataUltimaAtividade)}
              </MetricValue>
              <MetricHint>Envio/baixa/mix mais recente</MetricHint>
            </MetricCard>
          </CardsGrid>

          <SectionTitle>Mensageria no período</SectionTitle>
          <CardsGrid>
            <MetricCard>
              <MetricTitle>WhatsApp enviados</MetricTitle>
              <MetricValue>{drill.atual.whatsappEnviado}</MetricValue>
              <MetricHint>{drill.atual.whatsappFalha} falha(s)</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>E-mails enviados</MetricTitle>
              <MetricValue>{drill.atual.emailEnviado}</MetricValue>
              <MetricHint>{drill.atual.emailFalha} falha(s)</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Taxa de falha</MetricTitle>
              <MetricValue>
                {formatTaxaFalha(drill.atual.taxaFalha)}
              </MetricValue>
              <MetricHint>Falhas / total no período</MetricHint>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Rastreio (best-effort)</MetricTitle>
              <MetricValue>{drill.atual.entregues}</MetricValue>
              <MetricHint>
                entregues · {drill.atual.abertos} abertos · {drill.atual.lidos}{' '}
                lidos
              </MetricHint>
            </MetricCard>
          </CardsGrid>

          <SectionTitle>Adoção no período</SectionTitle>
          <CardsGrid>
            <MetricCard>
              <MetricTitle>Baixas</MetricTitle>
              <MetricValue>{drill.atual.numBaixas}</MetricValue>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Snapshots</MetricTitle>
              <MetricValue>{drill.atual.numSnapshots}</MetricValue>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Recomendações Mix</MetricTitle>
              <MetricValue>{drill.atual.numMixRecomendacoes}</MetricValue>
            </MetricCard>
            <MetricCard>
              <MetricTitle>Feedbacks Mix</MetricTitle>
              <MetricValue>{drill.atual.numMixFeedbacks}</MetricValue>
            </MetricCard>
          </CardsGrid>

          <SectionTitle>Série temporal</SectionTitle>
          <ChartWrapper>
            {serie.length > 0 ? (
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                height={300}
              />
            ) : (
              <MetricHint>Sem dados no período selecionado.</MetricHint>
            )}
          </ChartWrapper>
        </>
      )}
    </Container>
  )
}
